/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {Languages} from './Languages'
import {useSelector} from 'react-redux'
import {AUTH_TOKEN_COOKIE_KEY} from '../../../../app/constants'
import Cookies from 'js-cookie'
import {RootState} from '../../../../setup'

const HeaderUserMenu: FC = () => {
  const company: any = useSelector<RootState>(({account}) => account.appAccount)
  const logout = () => {
    localStorage.removeItem('persist:fleksUp')
    Cookies.remove(AUTH_TOKEN_COOKIE_KEY)
    document.location.reload()
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <div className={`symbol-label fs-8 fw-bold bg-primary text-inverse-primary`}>
              {company?.companyUser?.first_Name[0]}
            </div>
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {company?.companyUser?.first_Name} {company?.companyUser?.last_Name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span>
            </div>
            <span className='fw-bold text-muted text-hover-primary fs-7'>
              {company?.companyUser?.email}
            </span>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <Link to={'/settings/account/details'} className='menu-link px-5'>
          Profilim
        </Link>
      </div>
      <div className='menu-item px-5'>
        <Link to={'/settings/licence'} className='menu-link px-5'>
          Lisanslarım
        </Link>
      </div>
      <div className='menu-item px-5 d-none'>
        <Link to={'/tickets'} className='menu-link px-5'>
          Ticketlarım
        </Link>
      </div>
      <Languages />
      <div className='menu-item px-5'>
        <Link to={'/settings'} className='menu-link px-5'>
          Ayarlarım
        </Link>
      </div>
      <div className='menu-item px-5'>
        <span className='menu-link px-5' onClick={() => logout()}>
          Çıkış
        </span>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
